import { useContext } from 'react';
import { CompanyIcon } from '../icons/CompanyIcon';
import { CompanyTitleIcon } from '../icons/CompanyTitleIcon';
import { ColorScheduleContext } from '../providers/ColorScheduleProvider';
import { BootstrapLayout } from './BootstrapLayout';
import { useTranslation } from 'react-i18next';
import { getNavigation } from '../utils/menuitems';
import { AppContext } from '../providers/AppProvider';
import { getConnectionIcon } from '../icons/ConnectionIcons';
import { useConnection } from '../providers/ConnectionProvider';
import { Navbar } from 'react-bootstrap';
import { appConfig } from '../environment';

export const MainHeader = (props: any) => {
    const colorSchedule = useContext(ColorScheduleContext).colorSchedule;

    return (
        <div id="header" style={{
            color: colorSchedule.headerTextColor,
            background: `linear-gradient(to bottom,  ${colorSchedule.headerColorFrom} 0%,${colorSchedule.headerColorTo} 100%)`
        }}>
            <BootstrapLayout>
                <Header />
            </BootstrapLayout>
        </div>
    )
}

export const Header = (props: any) => {
    const { t } = useTranslation();
    const { connected } = useConnection();
    const colorSchedule = useContext(ColorScheduleContext).colorSchedule;
    const app = useContext(AppContext).app;
    const locale = app.language;
    const nightMode = app.nightMode;
    const sideBars = app.sideBars;

    const currentYear = new Date().getFullYear();
    const companyName = t("company.name");
    const motto = t("company.motto");
          
//    const connectionIcon = connectionConfig.enabled ? (connected ? (<WifiOnlineIcon color={colorSchedule.headerTextColor} />) : (<WifiOfflineIcon color={colorSchedule.headerTextColor} />)) : <></>;
    const connectionIcon = getConnectionIcon({ color: colorSchedule.headerTextColor, connected, mobile: false });

    console.log("Drawn connection icon");

    return (
        <div key="header" style={{ backgroundColor: "transparent" }}>
            <div key="table" style={{ display: 'table' }}>
                <div key="tableRow" style={{ display: 'table-row' }}>
                    <div key="tableCellLeft" style={{ display: 'table-cell' }}>
                        <div key="logoIcon" style={{ paddingTop: "0.3em", paddingBottom: "0.3em" }}>
                            <CompanyIcon color={colorSchedule.iconColor} stopColor={colorSchedule.icon2Color} height="5.5em" width="4em" />
                        </div>
                    </div>
                    <div key="tableCellRight" style={{ display: 'table-cell', verticalAlign: "top", float: "none", paddingTop: "0.3em" }} >
                        <div key="subTable" style={{ paddingLeft: "0.6em", display: 'table', verticalAlign: "top" }} >
                            <div key="subTableRowTop" style={{ display: 'table-row', textAlign: "center" }}>
                                <div key="titleIcon" style={{ display: "table-cell" }}>
                                    <CompanyTitleIcon color={colorSchedule.iconColor} height="1.625em" width="12.5em" />
                                </div>
                                <div style={{ paddingLeft: '35px', verticalAlign: "top"}}>
                                     {connectionIcon}
                                </div>
                            </div>
                            <div key="subTableRowBottom" style={{ display: 'table-row', textAlign: "center" }}>
                                <div key="subTableCellBottom" style={{ display: "table-cell" }} >
                                    {/* <div key="motto" style={{ paddingTop: "0.1875em", fontSize: "1.0625em", color: colorSchedule.headerTextColor, cursor: 'default', textAlign: "center", fontWeight: "normal" }}>{motto}</div> */}
                                    <a href={getNavigation("automation", locale, nightMode, sideBars)}>
                                        <div key="motto" style={{ paddingTop: "0.1875em", fontSize: "1.0625em", color: colorSchedule.headerTextColor, cursor: 'default', textAlign: "center", fontWeight: "normal" }}>{motto}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const Footer = (props: any) => {
    const { t } = useTranslation();    
    const colorSchedule = useContext(ColorScheduleContext).colorSchedule;
    const app = useContext(AppContext).app;
    const sideBars = app.sideBars;

    const startYear = appConfig.startYear;
    const currentYear = new Date().getFullYear();
    const companyName = t("company.name");

    return (
        <>
            {/* <Navbar style={{ backgroundColor: "white", height: "25px" }} fixed='bottom' expand="lg" className="footer">
            </Navbar> */}
            <Navbar style={{ backgroundColor: sideBars ? colorSchedule.jumbotronColorTo : colorSchedule.surfaceColorTo, height: "35px", minHeight: "25px", left: "0%", width: "100%" }} fixed='bottom' expand="lg" className="footer">
                <div className='small-text' style={{ color: colorSchedule.headerTextColor, textAlign: "center", width: "100%", textWrap: "nowrap" }}>
                    &copy;{startYear}-{currentYear} {companyName} - All rights reserved 
                </div>
            </Navbar>
        </>
    );
}